import GenerateAdtInfoImportFilePanel from "./generateAdtInfoImportFilePanel.container";

export default GenerateAdtInfoImportFilePanel;
